import {quillEditor} from "vue-quill-editor";
import {QUILL_MODULES_PRICING} from "@/constants/optionsConstants";
import {PRICING_CARD_DROPDOWN_OPTIONS} from "@/constants/cardPrices";
import {mapActions, mapGetters} from "vuex";

const lvlDefault = {
  bg: 'black',
  fg: 'white',
  body: '',
  img: '/img/solo.svg',
  price: '0',
  items: '',
  summary: '',
  title: ''
}

export default {
  components: {
    quillEditor
  },

  data() {
    return {
      dialog: false,
      checkbox: true,
      priceErrorMsg: '',
      priceDiff: 0,
      collaborativeData: {
        WithSpouse: {...lvlDefault},
        level_1: {...lvlDefault},
        level_2: {...lvlDefault},
      },
      unilateralData: {
        WithoutSpouse: {...lvlDefault},
        level_1: {...lvlDefault},
        level_2: {...lvlDefault}
      },
      selectedDropdown: '',
      editorOption: {
        modules: QUILL_MODULES_PRICING,
        placeholder: 'Write here something'
      },
      snackbar: false,
      snackSuccess: false,
    }
  },

  computed: {
    ...mapGetters({
      prices: 'prices/getCardCosts'
    }),
    constantValue() {
      return PRICING_CARD_DROPDOWN_OPTIONS;
    },
    description() {
      if(this.replacements.length > 0) {
        let description = this.items
        this.replacements.forEach(r => {
          Object.entries(r).forEach(([key, value]) => {
            description = description.replace(`{{${key}}}`, value)
          })
        })
        return description
      } else if(this.price) {
        return this.items.replace('{{total}}', this.price)
      }
      return this.items
    }
  },

  props: {
    price: {
      "Type": String
    },
    btnName: {
      "Type": String,
      default: 'Select'
    },
    summary: {
      "Type": String,
      required: false,
      default: ''
    },
    tab: {
      "Type": Object,
      required: true
    },
    items: {
      "Type": String,
      require: true
    },
    showSelectBtn: {
      "Type": Boolean,
      default: false
    },
    image: {
      "Type": String,
      required: false,
      default: ''
    },
    replacements: {
      "type": Array,
      required: false,
      default: () => []
    },
    tabItems: [],
    nameProp: '',
    previewChoice: '',
    collaborativePricingLevels: {},
    unilateralPricingLevels: {}
  },

  async mounted() {
    await this.getPrices()
  },

  methods: {
    ...mapActions('prices', ['getPrices']),

    selectedValue(data) {
      this.selectedDropdown = data
      if (this.nameProp === 'collaborative') {
        switch (data) {
          case PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_ONE:
            this.collaborativeData.level_1 = this.prices[0].level_1;
            break;
          case PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_TWO:
            this.collaborativeData.level_2 = this.prices[0].level_2;
            break;
          default:
            this.collaborativeData.WithSpouse = this.prices[0].WithSpouse;
        }
      } else {
        this.selectedDropdown = data
        switch (data) {
          case PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_ONE:
            this.unilateralData.level_1 = this.prices[1].level_1;
            break;
          case PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_TWO:
            this.unilateralData.level_2 = this.prices[1].level_2;
            break;
          default:
            this.unilateralData.WithoutSpouse = this.prices[1].WithoutSpouse;
        }
      }
    },

    dialogAction() {
      if (this.nameProp === 'collaborative') {
        const totalCol = this.collaborativeData.WithSpouse.price
        const level1Col = this.collaborativeData.level_1.price
        const level2Col = this.collaborativeData.level_2.price
        if ( Number(totalCol) !== Number(level1Col) + Number(level2Col)) {
          this.priceErrorMsg = 'Total price is not equal with level 1 and level 2 prices'
          this.priceDiff = Number(totalCol) - (Number(level1Col) + Number(level2Col))
          this.snackbar = true
        } else {
          this.$emit('dialogAction', {variant: this.nameProp, data: this.collaborativeData})
          this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_GENERAL
          this.priceErrorMsg = ''
          this.priceDiff = 0
          this.dialog = false
          this.snackSuccess = true
        }
      } else if (this.nameProp === 'unilateral') {
        const totalUni = this.unilateralData.WithoutSpouse.price
        const level1Uni = this.unilateralData.level_1.price
        const level2Uni = this.unilateralData.level_2.price
        if ( Number(totalUni) !== Number(level1Uni) + Number(level2Uni)) {
          this.priceErrorMsg = 'Total price is not equal with level 1 and level 2 prices'
          this.priceDiff = Number(totalUni) - (Number(level1Uni) + Number(level2Uni))
          this.snackbar = true
        } else {
          this.$emit('dialogAction', {variant: this.nameProp, data: this.unilateralData})
          this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_GENERAL
          this.priceErrorMsg = ''
          this.priceDiff = 0
          this.dialog = false
          this.snackSuccess = true
        }
      }
    },
    edit() {
      this.dialog = true;
      if (this.nameProp === 'collaborative') {
        this.collaborativeData.level_1 = this.prices[0].level_1;
        this.collaborativeData.level_2 = this.prices[0].level_2;
        this.collaborativeData.WithSpouse = this.prices[0].WithSpouse;

        switch (this.previewChoice) {
          case PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_ONE_PREVIEW:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_ONE_PREVIEW;
            this.collaborativeData.level_1 = this.prices[0].level_1;
            break;
          case PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_TWO_PREVIEW:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_LEVEL_TWO_PREVIEW;
            this.collaborativeData.level_2 = this.prices[0].level_2;
            break;
          default:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITH_SPOUSE_GENERAL_PREVIEW;
            this.collaborativeData.WithSpouse = this.prices[0].WithSpouse;
            break;
        }
      } else if (this.nameProp === 'unilateral') {
        this.unilateralData.level_1 = this.prices[1].level_1;
        this.unilateralData.level_2 = this.prices[1].level_2;
        this.unilateralData.WithoutSpouse = this.prices[1].WithoutSpouse;

        switch (this.previewChoice) {
          case PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW;
            this.unilateralData.level_1 = this.prices[1].level_1;
            break;
          case PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW;
            this.unilateralData.level_2 = this.prices[1].level_2;
            break;
          default:
            this.selectedDropdown = PRICING_CARD_DROPDOWN_OPTIONS.WITHOUT_SPOUSE_GENERAL_PREVIEW;
            this.unilateralData.WithoutSpouse = this.prices[1].WithoutSpouse;
            break;
        }
      }
    }
  }
}